import { useEffect, useRef, useCallback } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Features from "@/components/site/Features";
import UseCases from "@/components/site/UseCases";
import Manifesto from "@/components/site/Manifesto";
import About from "@/components/site/About";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollTo = useCallback((target) => {
    if (target === "#top") {
      lenisRef.current?.scrollTo(0, { offset: 0 });
      return;
    }
    const el = document.querySelector(target);
    if (el) lenisRef.current?.scrollTo(el, { offset: -80 });
  }, []);

  return (
    <div className="App">
      <div className="noise-overlay" aria-hidden="true" />
      <Toaster position="top-right" />
      <Navbar onScrollTo={scrollTo} />
      <main>
        <Hero onScrollTo={scrollTo} />
        <Marquee />
        <Features />
        <UseCases />
        <Manifesto />
        <About />
        <Contact />
      </main>
      <Footer onScrollTo={scrollTo} />
    </div>
  );
}

export default App;
